<template>
  <div>
    <app-heading
      :text="'* Service Qualification'"
      :heading="'main'"
    ></app-heading>
    <v-divider class="mt-6 mb-4"></v-divider>
    <qualification-form-5g
      ref="qualificationForm"
      @showResultSection="showResultSection"
      @toggleInput="toggleInput"
      @changed="changed"
    ></qualification-form-5g>
    <qualification-result-5g
      ref="qualificationResult5g"
      class="mt-5"
      :showButtons="true"
      :showLocIdInput="showLocIdInput"
      :queryAddress="queryAddress"
      :addressState="addressState"
      :hideOtherButtons="false"
      :withData="true"
      :selected="selected"
      @createOrder="setNewOrder"
      :hasMatch="hasMatch"
    >
    </qualification-result-5g>
    <create-order-5g
      ref="createOrder"
      :showNewOrder="showNewOrder"
      @close="closeNewOrder()"
    ></create-order-5g>
  </div>
</template>

<script>
export default {
  name: "ServiceQualification",
  data: () => ({
    showNewOrder: false,
    queryAddress: [],
    addressState: "",
    streetAddress: "",
    populatedAddress: {},
    sqNbnProcessing: false,
    sq5GProcessing: false,
    showLocIdInput: false,
    id: "",
    selected: "Physical Address",
    isFeatureOn: false,
    primaryAccessTechnology: "",
    hasMatch: true,
  }),
  mounted() {
    let vm = this;
    vm.reset5gSq();
    vm.setOrderType("nbn");
    if (vm.featureFlags && vm.featureFlags.connect5GSq) vm.isFeatureOn = true;
  },
  methods: {
    closeNewOrder() {
      let vm = this;
      vm.showNewOrder = false;
    },
    showResultSection(details) {
      let vm = this;
      vm.$refs.qualificationResult5g.showSqResult = false;

      if (vm.orderType === "nbn") {
        if (vm.selected === "Physical Address") {
          vm.hasMatch =
            details.result.addresses && details.result.addresses.length > 0;
        }

        vm.queryAddress = details.queryAddress;
        vm.streetAddress = details.streetAddress;
        vm.populatedAddress = details.populatedAddress;

        if (
          details.queryAddress.length === 1 &&
          details.queryAddress.length !== 0
        ) {
          vm.showLocIdInput = false;
          vm.setLocationID(vm.queryAddress[0].locationId);
          vm.serviceQualification(details.queryAddress[0]).then((data) => {
            data.data.parameters.parameter.forEach((x) => {
              if (x.name === "PrimaryAccessTechnology")
                vm.primaryAccessTechnology = x.value;
            });
            vm.getExcludedProducts(vm.primaryAccessTechnology).then(() => {
              if (vm.isProductExcluded) {
                vm.setHttpResponse({
                  text: vm.invalidProductErr,
                  color: "error",
                });
              }
            });

            vm.setFormattedSQResult(data.data);

            this.$nextTick(() => {
              vm.$refs.qualificationResult5g.result = data.data;
              vm.$refs.qualificationResult5g.showSqResult = true;
            });
          });
        } else vm.showLocIdInput = true;
      } else {
        if (vm.selected === "Physical Address") {
          vm.hasMatch = vm.sq5gResult.location.length > 0;
        }

        this.$nextTick(() => {
          vm.$refs.qualificationResult5g.showSqResult = true;
        });
      }
    },

    async setNewOrder() {
      let vm = this;

      if (vm.orderType === "5g") {
        let accountId = "5G";
        vm.getMsnList(accountId);

        vm.getSimList(accountId);
      }

      vm.showNewOrder = true;

      // let request = await vm.createNewOrder({
      //   locationId: "LOC000059754013",
      //   customerAuthDate: new Date(),
      //   contractLength: 12,
      // });
      // debugger;

      //vm.$refs.createOrder.details = data;

      // if (data.sqResult.parameters.parameterGroup) {
      //   vm.$refs.createOrder.ntd = data.sqResult.parameters.parameterGroup.map(
      //     (x) => x.groupName
      //   );

      //   if (data.sqResult.parameters.parameterGroup.length === 1) {
      //     vm.$refs.createOrder.unid = data.sqResult.parameters.parameterGroup[0].parameter.filter(
      //       (x) => x.name.includes("UNI-D")
      //     );
      //   } else {
      //     vm.$refs.createOrder.unid = [];
      //   }

      //   vm.$refs.createOrder.newOrder = {
      //     locationId: vm.locationID,
      //     orderType: "",
      //     customerAuthDate: "",
      //     requestedSpeed: "",
      //     contractTerm: "",
      //     customer: {
      //       firstName: "",
      //       lastName: "",
      //       contactNo: "",
      //       email: "",
      //     },
      //     operatorContactEmail: "",
      //     operatorContactNumber: "",
      //     serviceId: data.sqResult.correlationId,
      //     accessLoopId: vm.formattedSQResult.csaid
      //       ? vm.formattedSQResult.csaid
      //       : "",
      //     operatorFirstname: "",
      //     operatorSurname: "",
      //     customerReference: data.sqResult.correlationId,
      //     cpiID:
      //       data.sqResult.parameters.parameterGroup.length === 1
      //         ? data.sqResult.parameters.parameterGroup[0].groupName
      //         : "",
      //     unidPortID: "",
      //     installationWorkforce: "",
      //     portingNumber: 0,
      //     specialInstructions: "",
      //     deliveryInstructions: "",
      //     ticketId: data.sqResult.correlationId,
      //   };
      // }
    },
    toggleInput(state) {
      let vm = this;
      vm.showLocIdInput = state;
      vm.$refs.qualificationResult5g.hideResult();
    },
    changed(selected) {
      let vm = this;
      vm.showLocIdInput = false;
      vm.$refs.qualificationResult5g.showSqResult = false;
      vm.$refs.qualificationResult5g.hideResult();
      vm.queryAddress = [];

      vm.hasMatch = true;

      if (selected !== undefined) {
        vm.selected = selected;
      }
    },
  },
  computed: {
    invalidProductErr() {
      let vm = this;
      return vm.$route.path === "/"
        ? `${vm.primaryAccessTechnology} is not included in our services. Can't proceed with the order.`
        : `${vm.primaryAccessTechnology} is not included in our services.`;
    },
  },
};
</script>

<style lang="scss" scoped></style>